import { SetWiseOperator, UnaryOperator } from "./forms";
export class OrOperator extends SetWiseOperator {
    get rawOperator() {
        return (l, r) => l || r;
    }
}
export class AndOperator extends SetWiseOperator {
    get rawOperator() {
        return (l, r) => l && r;
    }
}
export class NotOperator extends UnaryOperator {
    apply(env) {
        return !this.param.apply(env);
    }
}
